import { css } from '@emotion/react';

export default $ => css`
  .editor-container {
    > .editor-sidebar {
      z-index: 100;
      > .sidebar-panel {
        min-height: 0;
        display: flex;
        flex-direction: column;

        &:only-of-type {
          height: 100%;
        }

        > .collapse.show {
          flex-grow: 1;
          overflow: auto;
        }

        > .collapse.show,
        > .collapsing {
          min-height: 0;
          display: flex;
          width: 100%;

          > .divComponents {
            min-height: 0;
            max-height: 100%;
            width: 100%;

            > ._formEditor {
              min-height: 0;
              height: 100%;
              display: flex;
              flex-direction: column;

              > .tab-content {
                min-height: 0;
                max-height: 100%;
                overflow-y: auto;

                > .tab-pane > .container {
                  height: 100%;
                }
              }
            }
          }
        }
      }
    }
    > .editor-sidebar-collapse-button {
      position: absolute;
      left: 0;
      bottom: 0;
      z-index: 90;
    }
  }

  .editor-container:not(.horizontal-mode) {
    overflow: hidden;
    position: relative;

    > .editor-main-container {
      position: absolute;
      top: 0;
      height: 100%;
      left: 0;
      overflow: auto;
    }

    > .editor-sidebar {
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      margin-left: 3px;
      overflow-x: hidden;
      overflow-y: auto;
      border-radius: ${$.borderRadius} ${$.borderRadius} 0 0;
      background-color: ${$.white};

      > .sidebar-panel {
        position: relative;
      }
    }
    > .editor-sidebar-collapse-button {
      left: 0;
      top: 0;
      bottom: auto;
      transform: translate(-65%, 0px);
      > .btn {
        line-height: 2.1em;
        border-top-left-radius: 100px;
        border-bottom-left-radius: 100px;
        padding-left: 10px;
        padding-right: 18px;
      }
      &.collapsed > .btn {
        padding-right: 10px;
        &:hover {
          padding-right: 35px;
        }
      }
    }

    > .adjuster-edge {
      z-index: 105;
      position: absolute;

      &:hover {
        background-color: ${$.primaryMain};
        transition: background-color 2s ease-out;
      }

      &.active {
        background-color: ${$.primaryMain};
      }

      &.horizontal {
        left: 0;
        right: 0;
        height: 3px;
        cursor: ns-resize;
      }

      &.vertical {
        top: 0;
        bottom: 0;
        width: 3px;
        cursor: ew-resize;
      }
    }
  }

  .editor-container.horizontal-mode {
    position: relative;

    > .adjuster-edge {
      z-index: 100;
      position: absolute;

      &:hover {
        background-color: ${$.primaryMain};
        transition: background-color 2s ease-out;
      }

      &.active {
        background-color: ${$.primaryMain};
      }

      &.horizontal {
        left: 0;
        right: 0;
        height: 3px;
        cursor: ns-resize;
      }

      &.vertical {
        top: 0;
        bottom: 0;
        width: 3px;
        cursor: ew-resize;
      }
    }
    > .editor-sidebar-collapse-button {
      left: auto;
      right: 0;
      bottom: 0;
      top: auto;
      transform: translate(-60%, 1px);
      > .btn {
        padding-top: 5px;
        line-height: 1em;
        width: 3em;
        border-top-left-radius: 100px;
        border-top-right-radius: 100px;
      }
      &.collapsed > .btn {
        padding-bottom: 5px;
        &:hover {
          padding-bottom: 25px;
        }
      }
    }
  }

  .tree-view {
    > .title {
      display: flex;
      justify-content: space-between;
      position: relative;
      flex-wrap: nowrap;

      > .title-label {
        width: 100%;

        > div {
          display: flex;
          align-items: center;
          flex-flow: row nowrap;
          min-width: 0;
          width: 100%;

          .title-text {
            min-width: 0;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
      }

      > .buttons {
        position: absolute;
        height: 100%;
        right: 0;
        padding-right: 8px;
        white-space: nowrap;
        background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 8px);
        padding-left: 8px;
        z-index: 10;

        > .btn {
          line-height: 1em;
          padding: 2px;
          transition: transform 100ms ease-in-out;

          &:hover {
            transform: scale(1.1);
          }
        }
      }
    }

    &:hover:not(:has(.tree-view:hover)) {
      background-color: #00000008;
      .title .buttons {
        background: inherit;
      }
    }

    &.selected {
      > .title {
        background-color: ${$.infoMain};
        color: white;

        > .buttons {
          background: linear-gradient(90deg, ${$.infoMain}00 0%, ${$.infoMain} 8px) !important;

          > .btn {
            color: white !important;
          }
        }
      }
    }
  }

  .draggable-list-item {
    position: relative;

    i.fa {
      padding-right: 5px;
      cursor: pointer;
    }
  }

  .dropzone-targets {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;

    > * {
      position: absolute;
    }

    &.has-left {
      > .top {
        left: 10%;
      }
      > .bottom {
        left: 10%;
      }
    }

    &.has-right {
      > .top {
        right: 10%;
      }
      > .bottom {
        right: 10%;
      }
    }

    > .top {
      top: 0;
      left: 0;
      right: 0;
      height: 50%;
    }

    > .bottom {
      bottom: 0;
      left: 0;
      right: 0;
      height: 50%;
    }

    > .left {
      top: 0;
      bottom: 0;
      left: 0;
      width: 10%;
    }

    > .right {
      top: 0;
      bottom: 0;
      right: 0;
      width: 10%;
    }

    &.visible {
      > .top {
        background-color: rgba(255, 0, 0, 0.35);
      }

      > .bottom {
        background-color: rgba(0, 255, 0, 0.35);
      }

      > .left {
        background-color: rgba(0, 0, 255, 0.35);
      }

      > .right {
        background-color: rgba(255, 255, 0, 0.35);
      }
    }
  }
`;
